import React, { FC } from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { AccountBalance as BankingIcon } from '@mui/icons-material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';

type Props = {
  step: number;
};

const StepHeader: FC<Props> = ({ step }) => {
  const theme = useTheme();

  const iconColor = theme.palette.primary.main;
  const circleBg = '#F2F4F8';

  return (
    <Box display="flex" flexDirection="row" alignItems="center" sx={{ mt: '4vh' }}>
      <Box
        sx={{
          p: 1.5,
          bgcolor: circleBg,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 32,
          height: 32,
        }}
      >
        {step === 1 ? (
          <BankingIcon sx={{ color: iconColor, fontSize: 17 }} />
        ) : (
          <PersonOutlineIcon sx={{ color: iconColor, fontSize: 17 }} />
        )}
      </Box>
      <Typography sx={{ fontWeight: 600, fontSize: '22px', ml: '10px' }}>
        {step === 1 ? 'Dados da empresa' : 'Dados do responsável'}
      </Typography>
    </Box>
  );
};

export default StepHeader;
